import React from "react";

const useScreenDimensions = () => {
  const [screenDimentions, setScreenDimentions] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const windowResizeHandler = () => {};
    window.addEventListener("resize", () => {
      setScreenDimentions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    });

    return () => {
      window.removeEventListener("resize", windowResizeHandler);
    };
  }, []);

  return screenDimentions;
};

export default useScreenDimensions;
